import * as React from 'react';
import MessageDialog from '../Utilities/messagedialog';
import {NotifyLostCard,  GetAdminUsers } from '../../REST/alert'
import {getWorkorderBuilder,simulateMyWorkorder} from "../../REST/workorders"
import {
  Button, Box, Typography, TextField, MenuItem, Select, InputLabel, FormControl,FormHelperText
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SaveOutlined from '@mui/icons-material/SaveOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import WorkflowDialogShell from '../../themes/components/WorkflowDialogShell';

export const RequestLostCard = React.forwardRef((props, ref)=>{
    
    const [dialopen, setDialOpen] = React.useState(false);
    const [data,setData] = React.useState(null)
     
    React.useEffect(()=>{
        
        NotifyLostCard()
        .then((resp)=>{
            setData(resp.data)
            
        })
    },[])
    
    const handleClose= ()=>{
        setDialOpen(false)
    }
    const handleOpen =() =>{
        setDialOpen(true)
    }
    if(data == null) return <></>
    const header = ()=>{
        return (
        <Typography variant="caption" color={"RED"} >( Please input Information before clicking send)</Typography>
        )
      }
    return (
        <>
             <Button variant="landing-action" ref={ref} onClick={handleOpen} fullWidth endIcon={<ChevronRightIcon />}>Contact Us</Button>
            {
                dialopen &&
                <MessageDialog handleClose={handleClose}  open={dialopen}  userIds={data.userIds} body={data.body}
                title = {"Lost or Stolen Card"} Extraheader={header} />
            
            }
        </>          
    )
})
export const  ContactUs =  React.forwardRef((props,ref)=>{
    
    const [dialopen, setDialOpen] = React.useState(false);
    const [usersIds,setUserIds] = React.useState(null)
    React.useEffect(()=>{
        GetAdminUsers("Internal")
        .then(({data})=>{
            setUserIds(data.userIds)
            
        })
    },[])
    
    const handleClose= ()=>{
        setDialOpen(false)
    }
    const handleOpen =() =>{
        setDialOpen(true)
    }
   
    return (
        <>
             <Button variant="landing-action" ref={ref} onClick={handleOpen} fullWidth endIcon={<ChevronRightIcon />}>Contact Us</Button>
            {
                dialopen &&
                <MessageDialog handleClose={handleClose}  open={dialopen}  userIds={usersIds}
                title = {"Contact Us"}  />
            
            }
        </>          
    )
})

export const WrapperBox = ({Widget,children})=>{
    const ref = React.useRef(null);
    const handleParentClick = (event) => {
         if(event.currentTarget.contains(event.target))
         {
            ref.current.click();
         }
         
        
      };
    return (
        <Box   sx={{"& button":{display:"none"},width:1,height:1}} onClick={handleParentClick} >
                <Widget ref={ref} />
                {children}
        </Box>

    )
}

export const WorkOrderRequest = React.forwardRef((props, ref) => {
  const [dialopen, setDialOpen] = React.useState(false);
  const [workOrderType, setWorkOrderType] = React.useState('');
  const [types,setTypes] = React.useState(null)
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [iframeOpen, setIframeOpen] = React.useState(false);
  const [iframeLink, setIframeLink] = React.useState('');
  const [saving,setSaving] = React.useState(false)
  const [savedSuccess, setSavedSuccess] = React.useState(false)
  const [errors, setErrors] = React.useState({});

  const frame = React.useRef(null)

  const handleClose = () => {
    setDialOpen(false);
  };

  const handleOpen = () => {
    setDialOpen(true);
  };

  const handleIframeClose = () => {
    setIframeOpen(false);
    setIframeLink('');
  };
  const validate = () => {
    const newErrors = {};
    if (!workOrderType){
        newErrors.workOrderType = 'Please select a work order type.';
    }
    else  delete newErrors.workOrderType

    if (!name.trim()) {
      newErrors.name = 'Name is required.';
    }
    else delete  newErrors.name

    if (!email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = 'Invalid email format.';
    }
    else delete  newErrors.email

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async () => {
     if (!validate()) return; // Stop if form is invalid
    setLoading(true);
    try {
      const { data } = await simulateMyWorkorder({ workorderId:workOrderType, name, email,source: "External" });
      if (data.link) 
      {
        setIframeLink(data.link);
        setIframeOpen(true);
      }
      setWorkOrderType('');
      setName('');
      setEmail('');
      setErrors({});
      handleClose();
    } catch (err) {
      console.error("Submission failed", err);
    } finally {
      setLoading(false);
    }
  };
 const saveFrame = ()=>{
      frame.current.contentWindow.postMessage("callSave","*");
      return new Promise((resolve) => setTimeout(resolve, 3000))
  }
  const handleFrameSubmit = function(){
    setSavedSuccess(true);
    saveFrame().then(handleIframeClose);
  }
  React.useEffect(()=>{

    getWorkorderBuilder()
    .then(({data})=>{
        setTypes(data)
    })

  },[]) 

   React.useEffect(() => {
    const handleMessage = (event) => {
      if (event.data === 'formsaved') {
        setSavedSuccess(true);
        handleIframeClose();
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <>
      <Button variant="landing-action" ref={ref} onClick={handleOpen} fullWidth endIcon={<ChevronRightIcon />}>
        Add New
      </Button>
      {
        dialopen &&
        <WorkflowDialogShell
          open={dialopen}
          onClose={handleClose}
          onSave={handleSubmit}
          title="Add WorkOrder"
          saveLabel={loading ? "Saving..." : "Next"}
          saveDisabled={loading || !types}
        >
          <Box display="flex" flexDirection="column" gap={2}>
            <Typography variant="body2" color="text.secondary">
              Choose a work order type and enter your contact details to continue.
            </Typography>
            <FormControl fullWidth error={!!errors.workOrderType} >
                <InputLabel>Work Order Type</InputLabel>
                <Select
                 error={!!errors.workOrderType} 
                value={workOrderType}
                onChange={(e) => setWorkOrderType(e.target.value)}
                label="Work Order Type"
                >
                    {
                        (types || []).filter(t => t.isPublic).length === 0 ? (
                            <MenuItem disabled>No public workorder types available</MenuItem>
                        ) : (
                            (types || []).filter(t => t.isPublic).map((t)=>(
                                <MenuItem key={t._id} value={t._id}>{t.name}</MenuItem>
                            ))
                        )
                    }
                
                </Select>
                
                 {errors.workOrderType && <FormHelperText>{errors.workOrderType}</FormHelperText>}
            </FormControl>
            <TextField label=" Tenant Name" value={name} onChange={(e) => setName(e.target.value)} fullWidth 
              error={!!errors.name}
              helperText={errors.name}
              variant="standard"
              />
            <TextField label=" Tenant Email" value={email} onChange={(e) => setEmail(e.target.value)} fullWidth 
               error={!!errors.email}
               helperText={errors.email}
               variant="standard"
            />
          </Box>
        </WorkflowDialogShell>
        
      }
      {
        iframeOpen && 
        <Dialog fullScreen open={true} onClose={handleIframeClose}>
         <AppBar sx={{ position: 'relative' }}>
          <Toolbar style={{ justifyContent: 'space-between' }}>
            <IconButton edge="start" color="inherit" onClick={  handleIframeClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Fill Work Order
            </Typography>
          </Toolbar>
        </AppBar>
        <Box display="flex" width="100%" height="100%">
            <iframe
              ref={frame}
              src={iframeLink}
              style={{ width: '100%', height: '100%', border: 'none' }}
              title="Work Order"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              width="100%"
              height="100%"          
              scrolling="auto"
            />
        </Box>
      </Dialog>
      }
      <Snackbar
        open={savedSuccess}
        autoHideDuration={3000}
        onClose={() => setSavedSuccess(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="success" onClose={() => setSavedSuccess(false)} sx={{ width: '100%' }}>
          Saved successfully!
        </Alert>
      </Snackbar>
    </>
  );
});
 
